import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { useTranslation } from 'react-i18next';
import { IonRouterLink } from '@ionic/react';
import React, { useEffect, useState } from 'react';
import { api } from '@/utils/api';

type Like = {
  id: number;
  createdAt: string;
  user: {
    username: string;
    firstName: string;
    lastName: string;
    avatar: string | null;
  };
};

type PostLikesProps = {
  postId: number;
  onClose?: () => void;
};

const PostLikes: React.FC<PostLikesProps> = ({ postId }) => {
  const [likes, setLikes] = useState<Like[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation();

  // Fetch likes when opened
  useEffect(() => {
    const fetchLikes = async () => {
      setIsLoading(true);
      try {
        const { data } = await api.get(`/api/posts/likes?postId=${postId}`);
        setLikes(data);
      } catch (error) {
        console.error('Failed to load likes:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchLikes();
  }, [postId]);

  return (
    <div className="flex flex-col">
      {/* Likes List */}
      <div className="flex-1 space-y-2 overflow-y-auto p-4">
        {isLoading
          ? (
            <p>Loading likes...</p>
          )
          : likes.length > 0
            ? (
              likes.map(like => (
                <div key={like.id} className="flex items-center space-x-4 rounded-lg p-2 transition-colors">
                  <IonRouterLink href={`/${like.user.username}`}>
                    <Avatar>
                      <AvatarImage src={like.user.avatar!} alt={like.user.username} />
                      <AvatarFallback>{like.user.username[0]}</AvatarFallback>
                    </Avatar>
                  </IonRouterLink>
                  <div className="flex flex-col">
                    <IonRouterLink href={`/${like.user.username}`} key={like.id}>
                      <span className="font-semibold">
                        {like.user.username}
                      </span>
                    </IonRouterLink>
                    <span className="text-sm text-muted-foreground">
                      {like.user.firstName}
                      {' '}
                      {like.user.lastName}
                    </span>
                  </div>
                </div>
              ))
            )
            : (
              <div className="flex h-full items-center justify-center">
                <p>{t('no_results')}</p>
              </div>
            )}
      </div>
    </div>
  );
};

export default PostLikes;
